import installationMiddleware from './middleware';
import installationReducer, { installationSlice } from './reducer';
import * as installationSelectors from './selectors';

const installationActions = {
  ...installationSlice.actions,
};

export {
  installationActions,
  installationMiddleware,
  installationReducer,
  installationSelectors,
};
